import { api } from './api';

class ConfigService {
    // Get all configuration settings
    async getConfiguration() {
        return api.get('/api/admin/config');
    }

    // Update configuration settings
    async updateConfiguration(config) {
        return api.put('/api/admin/config', config);
    }

    // Get specific configuration section
    async getConfigSection(section) {
        return api.get(`/api/admin/config/${section}`);
    }

    // Update specific configuration section
    async updateConfigSection(section, config) {
        return api.put(`/api/admin/config/${section}`, config);
    }

    // Reset configuration to defaults
    async resetConfiguration() {
        return api.post('/api/admin/config/reset');
    }

    // Export configuration
    async exportConfiguration() {
        return api.get('/api/admin/config/export');
    }

    // Import configuration
    async importConfiguration(configData) {
        return api.post('/api/admin/config/import', configData);
    }

    async uploadPrivacyPolicyFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/admin/config/legal/privacy-policy-file', formData);
    }

    async deletePrivacyPolicyFile() {
        return api.delete('/api/admin/config/legal/privacy-policy-file');
    }

    async uploadVendorPrivacyPolicyFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/admin/config/legal/vendor-privacy-policy-file', formData);
    }

    async deleteVendorPrivacyPolicyFile() {
        return api.delete('/api/admin/config/legal/vendor-privacy-policy-file');
    }
}

export const configService = new ConfigService();